<div class="card h-100 shadow-sm">
  <lib-card
    [fullScreenMode]="true"
    [fullHeight]="true"
    >
    <lib-card-header>
      <div class="row">
        <div class="col-12 d-flex flex-wrap align-items-center">
          <div class="d-flex font-weight-bold text-primary font-size-normal mr-3 mr-sm-auto">
            {{"PERFORMANCE_MONITORING.TITLE" | translate}}
            @if (!data?.history) {
              <app-spinner></app-spinner>
            }
            <span class="float-right">
              @if (popupContent !== null) {
                <img
                  [alt]="'IMAGE_DESCRIPTION.INFO' | translate"
                  class="mx-2 info-icon"
                  [src]="'info-icon' | imageSrc | async"
                  [matTooltip]="popupContent | translate"
                  matTooltipPosition="below"
                />
              }
            </span>
          </div>
          @if (data?.history) {
            <div class="mr-3 d-flex flex-wrap mt-3 mt-md-0 content-box-buttons-monitoring">
              <div class="mr-2">
                <lib-content-box-buttons
                  [buttons]="['ALARMS.BUTTONS.ALARMS_ON', 'ALARMS.BUTTONS.ALARMS_OFF']"
                  [active]="activeAlarm"
                  (activeChanged)="handleActiveAlarmsChanged($event)">
                </lib-content-box-buttons>
              </div>
              <div>
                <lib-content-box-buttons
                  [buttons]="buttons"
                  [active]="active"
                  (activeChanged)="handleActiveChanged($event)">
                </lib-content-box-buttons>
              </div>
            </div>
          }
        </div>
      </div>
    </lib-card-header>
    <lib-card-body>
      <div id="performanceAnalyzeChartWrapper">
        <div class="overflowWrapper h-100 row">
          <div class="chartWrapper pt-3" [style.height]="data?.history?.weather ? 'calc(100% - 196px)' : '100%'">
            <app-monitoring-weather
              [weatherData]="weatherData"
            ></app-monitoring-weather>
            <div class="pl-2 h-100">
            </div>
            <div class="pl-2 h-100">
              @if (data?.history) {
                <app-performance-analyze-highchart
                  [data]="data?.history"
                  [yAxesPowerMax]="yAxesPowerMax"
                  [yAxesWindspeedMax]="yAxesWindspeedMax"
                  [rangeHours]="data?.hours"
                  [alarmsVisible]="!activeAlarm"
                  [alarms]="data?.alarmsNew"
                  [unit]="unit"
                  [haveLollipop]="data?.isLollipop"
                  class="h-100">
                </app-performance-analyze-highchart>
              }
            </div>
          </div>
        </div>
      </div>
    </lib-card-body>
  </lib-card>
</div>